import request from '@/services/interceptor.js'

export const get_utenti = () => {
    return request({ url: '/utenti', method: 'get', loadingBar: true })
}

export const create_utente = (par) => {
    return request({ url: '/utenti', method: 'post', data: par, loadingBar: true })
}

export const update_utente = (id, par) => {
    return request({ url: `/utenti/${id}`, method: 'put', data: par, loadingBar: true })
}

export const reset_password_utente = (id, nuovaPassword) => {
    return request({ url: `/utenti/${id}/reset-password`, method: 'post', data: { nuovaPassword }, loadingBar: true })
}

export const abilita_utente = (id) => {
    return request({ url: `/utenti/${id}/abilita`, method: 'put', loadingBar: true })
}

export const disabilita_utente = (id) => {
    return request({ url: `/utenti/${id}/disabilita`, method: 'put', loadingBar: true })
}

export const genera_embed_token = (id) => {
    return request({ url: `/utenti/${id}/embed-token`, method: 'post', loadingBar: true })
}

export const revoca_embed_token = (id) => {
    return request({ url: `/utenti/${id}/embed-token`, method: 'delete', loadingBar: true })
}
